<template>
	<nav class="fixed top-0 left-0 right-0 z-50 glass-nav border-b border-gray-200" style="height: 72px;">
		<div class="mx-auto px-6 py-4 flex items-center justify-between" style="width: 90%;">
			<div class="flex items-center space-x-8">
                <div><img src="@/assets/images/newlvlogo.png" alt="logo" style="width: 40px; height: 40px;"></div>
				<div class="text-2xl font-['Pacifico'] text-primary font-bold" @click="$router.push('/home')">义乌缕新</div>
				<div class="hidden md:flex items-center space-x-8">
					<a href="/home" class="text-gray-700 hover:text-primary transition-colors duration-200 relative group" :class="{ 'active': $route.path === '/home' }">网站首页
						<span class="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
					</a>
					<a href="/about" class="text-gray-700 hover:text-primary transition-colors duration-200 relative group" :class="{ 'active': $route.path === '/about' }">关于我们
						<span class="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
					</a>
					<a href="/phoneUs" class="text-gray-700 hover:text-primary transition-colors duration-200 relative group" :class="{ 'active': $route.path === '/phoneUs' }">联系我们
						<span class="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
					</a>
                    <a href="/shzpInfo" class="text-gray-700 hover:text-primary transition-colors duration-200 relative group" :class="{ 'active': $route.path === '/shzpInfo' }">社会招聘
						<span class="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full"></span>
					</a>
				</div>
			</div>
			<div class="flex">
                <div style="margin-right: 15px;"><img src="@/assets/images/phone.png" alt="phone" style="width: 20px; height: 20px;"></div>
				<div>18957969555</div>
			</div>
		</div>
	</nav>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'Nav',
    data() {
        return {
            isLogin: null,
        };
    },
    computed: {
        ...mapGetters(["name"]),
    },
    mounted() {
        this.isLogin = localStorage.getItem("token") ? true : false;
        // Add scroll effect to navigation
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            const nav = document.querySelector('.glass-nav');
            if (window.scrollY > 50) {
                nav.classList.add('scrolled');
            } else {
                nav.classList.remove('scrolled');
            }
        },
        logout() {
            this.$message.success('退出成功')
            localStorage.removeItem('token')
            this.isLogin = false
            this.$router.replace({
                path: '/login'
            })
        },
        login(e) {
            if (e == 'add') {
                this.$router.push('/register')
            } else {
                this.$router.push('/login')
            }
        },
        info() {
            this.$router.push({
                path: '/info'
            })
        },
    },
};
</script>

<style scoped>
/* 额外的自定义样式 */
.glass-nav {
  /* backdrop-filter: blur(10px);
  background: rgba(240, 240, 240, 0.85); */
    backdrop-filter: blur(12px); /* 轻微增强模糊，质感更细腻 */
  -webkit-backdrop-filter: blur(12px); /* 兼容Safari */
  background: rgba(255, 255, 255, 0.65); /* 高透明白底，高级感拉满 */
  border-bottom: 1px solid rgba(255, 255, 255, 0.2); /* 底部细边框，层次更清晰 */
}

.glass-nav.scrolled {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.rounded-button {
  border-radius: 4px;
}

.active {
  color: #409eff;
  font-weight: 500;
}

.active span {
  width: 100%;
}
</style>